export default __webpack_public_path__ + "static/media/CrownReduction.f5b3613a.jpg";